import { useState } from 'react';

import { Checkbox, Flex, useTheme, VStack } from '@chakra-ui/react';

import { useAppDispatch, useAppSelector } from 'store/hooks';
import { setCancellationPolicyModalOpen } from 'store/reducers/bookingAppointmentSlice';

import { Button, Modal, Text } from 'ui';

interface CancellationPolicyModalProps {
  onConfirm: () => void;
}

const CancellationPolicyModal = ({
  onConfirm
}: CancellationPolicyModalProps) => {
  const dispatch = useAppDispatch();
  const {
    colors: {
      palette: {
        components: { simpleErrorModal }
      }
    }
  } = useTheme();

  const [isChecked, setIsChecked] = useState<boolean>(false);

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(e.target.checked);
  };

  const { cancellationPolicyModalOpen } = useAppSelector(
    (state) => state.bookingAppointment
  );

  const onClose = () => {
    dispatch(setCancellationPolicyModalOpen(false));
  };

  const OnClick = () => {
    onClose();
    onConfirm();
  };

  return (
    <Modal
      isOpen={cancellationPolicyModalOpen}
      onClose={onClose}
      size={{ base: 'xs', md: '2xl', lg: '2xl', '3xl': '6xl' }}
      isCentered
    >
      <Flex gap={0} flexDirection={{ base: 'column', md: 'row' }}>
        <VStack
          align='center'
          flex='1'
          px={{ base: '20px', md: '40px', '2xl': '65px' }}
          py={{ base: '30px', md: '30px', lg: '40px', '2xl': '65px' }}
          gap={{ base: '12px', md: '20px' }}
        >
          <Text
            fontSize={{ base: '26px', md: '32px', lg: '38px' }}
            color={simpleErrorModal.titleColor}
            textAlign='center'
            pb='20px'
          >
            Appointment Courtesy & Cancellation Policy
          </Text>
          <Text
            fontSize={{ base: '18px', md: '20px' }}
            color={simpleErrorModal.descriptionColor}
            textAlign='center'
          >
            To reserve your appointment, we require a credit card on file in our
            secure booking system. We kindly ask for at least 24 hours’ notice
            to cancel or reschedule. Cancellations within 24 hours will be
            charged $75, and missed appointments (“no-shows”) will be charged
            $150.
          </Text>
          <Text
            fontSize={{ base: '18px', md: '20px' }}
            color={simpleErrorModal.descriptionColor}
            textAlign='center'
          >
            If you arrive more than 10 minutes late, we may need to reschedule
            to avoid disrupting other appointments.
          </Text>

          <Flex gap='16px' alignItems='center' py='20px'>
            <Checkbox
              variant='outline'
              colorScheme='secondary'
              size='md'
              isChecked={isChecked}
              onChange={handleCheckboxChange}
            >
              <Text fontSize='18px' lineHeight='140%'>
                I have read and agree to the cancellation policy
              </Text>
            </Checkbox>
          </Flex>

          <Flex
            w='100%'
            justifyContent='center'
            alignItems='center'
            gap='20px'
            flexDirection={{ base: 'column', md: 'row' }}
          >
            <Button
              w='272px'
              h='45px'
              isDisabled={!isChecked}
              onClick={OnClick}
            >
              COMPLETE BOOKING
            </Button>
          </Flex>
        </VStack>
      </Flex>
    </Modal>
  );
};

export default CancellationPolicyModal;
